import React, { lazy, Suspense, useState } from 'react';

//import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledCollapse, UncontrolledTooltip } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import OLMap from './OLMap.js'
const Blurb = lazy(() => import('./Blurb.js'));

const maxZoom = 20;
const defaultZoom = 3;
const defaultZoomResolution = 19.551; // km per pixel, see https://wiki.openstreetmap.org/wiki/Zoom_levels
const defaultCenter = [25, 10]; // lonlat!
const defaultLayer = 1;

const layerNames = ['0', 'a0', 'a1'];
const equator = 40075;

function App() {

  var initZoom = defaultZoom;
  var resolution = defaultZoomResolution;
  // figure out which zoom level would show full world width
  // all calculations in km
  var worldProportion = window.innerWidth * resolution / equator;
  while (initZoom > 0 && worldProportion < .5) {
    initZoom--;
    resolution *= 2;
    worldProportion = window.innerWidth * resolution / equator;
  }
  if (initZoom > 0) {
    initZoom -= (1 - worldProportion);
  }

  var initCenter = defaultCenter;
  var initLayer = defaultLayer;
  const args = (window.location.hash || '#').substring(1).split('/');
  if (args.length >= 3) {
    initZoom = parseFloat(args[0]);
    if (isNaN(initZoom) || initZoom < 0 || initZoom > maxZoom) {
      initZoom = defaultZoom;
    }

    initCenter = [parseFloat(args[2]), parseFloat(args[1])]; // store as lonlat!
    if (isNaN(initCenter[0]) || isNaN(initCenter[1]) || Math.abs(initCenter[0]) > 180 || Math.abs(initCenter[1]) > 80) {
      initCenter = defaultCenter;
    }

    if (args.length >= 4) {
      initLayer = layerNames.indexOf(args[3]);
      if (initLayer === -1) {
        initLayer = defaultLayer;
      }
    }
  }
  const [zoom, setZoom] = useState(initZoom);
  const [center, setCenter] = useState(initCenter);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [activeTab, setActiveTab] = useState('1');
  const toggleTab = tab => {
    if(activeTab !== tab) setActiveTab(tab);
    window.gtag('event', 'screen_view', { 'app_name': 'imaginedcommunities', 'screen_name': 'about:' + tab });
  }

  const [debug, setDebug] = useState(false);
  const toggleDebug = () => {
    if (!debug) {
      setModal(false);
      window.gtag('event', 'screen_view', { 'app_name': 'imaginedcommunities', 'screen_name': 'about' });
    }
    setDebug(!debug);
  }

  const goTo = (zoom, lon, lat) => {
    setModal(false);
    setZoom(zoom);
    setCenter([lon, lat]); // this triggers the OLMap's internal animation, which also activates the a0 layer
    window.gtag('event', 'select_content', { 'app_name': 'imaginedcommunities', 'content_type': 'suggestedpanzoom', 'items': [{ 'id': [zoom, lon, lat].join("/") }] });
  };

  const setHash = (zoom, center, layer) => {
    // most beautiful line of code in here
    if (zoom !== defaultZoom || center !== defaultCenter || layer !== defaultLayer) {
      const spec = [zoom.toPrecision(2)].concat(center.reverse().map((co) => co.toPrecision(6))).join('/');
      window.location.hash = spec + (layer === defaultLayer ? '' : '/' + layerNames[layer]);
    }
  };

  return (
    <>
    <OLMap id="map" setHash={setHash} toggleOverlay={toggle} maxZoom={maxZoom} zoom={zoom} center={center} communityIndex={initLayer} debug={debug} />
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => { toggleTab('1'); }}>imagined communities</NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => { toggleTab('2'); }}>borders</NavLink>
            </NavItem>
          </Nav>
        </ModalHeader>
        <Suspense fallback={<ModalBody>Loading...</ModalBody>}>
          <Blurb activeTab={activeTab} toggleTab={toggleTab} debug={debug} toggleDebug={toggleDebug} goTo={goTo} />
        </Suspense>
      </Modal>
    </div>
    </>
  );
}

//               unlike (1) it acknowledges that there are frontiers/uninteresting land, or areas which are occupied commercially, not socially, but also against
//              it shows "a physical reality that is distinct from implied homogeneity of the soverignty map, and partially influence by the imagination and identity of the people"

// "it derives its force from the individuals' will to ..."

//derived from <a href="http://sedac.ciesin.columbia.edu/data/collection/gpw-v4/sets/browse" target="_blank" rel="noopener noreferrer">Gridded Population of the World</a>, 
//        <ModalFooter>
//          <Button color="primary" onClick={toggle}>Do Something</Button>{' '}
//          <Button color="secondary" onClick={toggle}>Cancel</Button>
//        </ModalFooter>

// slabs: https://haramiran.org/coloring-ideas/world-map-coloring-page-with-countries.html
// slabs: https://adagebiopower.com/unmarked-world-map/

export default App;
